// extracted by mini-css-extract-plugin
export default {"note-view-content":"note-view-content---RmpsS","note-details-container":"note-details-container---gCErZ"};